const fireCaWiseHotelTag = async (
  _window,
  _document,
  reservationId,
  hash,
  encryptedReservation,
) => {
  const accountId = '44922';

  function executeTag(e, t, n, r, a, b, c, s) {
    e.TrackerObject = a;
    e[a] =
      e[a] ||
      function() {
        (e[a].q = e[a].q || []).push(arguments);
      };
    e[a].l = 1 * new Date();
    e[a].c = b;
    q = t.location.search.substring(1);
    c = t.createElement(n);
    s = t.getElementsByTagName(n)[0];
    c.async = 1;
    c.src =
      r + '?_t=' + e[a].l + '&_trk-type=cv&_trk-cid=' + b + (q ? '&' + q : '');
    s.parentNode.insertBefore(c, s);
  }

  executeTag(
    _window,
    _document,
    'script',
    "https://script-ad.mobadme.jp/js/tracker.js",
    'trk',
    accountId
  );
  // ここより上はできた

  trk("configure", "type", "2");
  trk("configure", "status", "1");
  trk("configure", "uId", reservationId);
  trk("configure", "hash", hash);
  trk("configure", "trvl_p", encryptedReservation);
  trk("send", accountId);
}

module.exports = fireCaWiseHotelTag;
